import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { sliders } from '../data/products';
import ImageWithSkeleton from './ImageWithSkeleton';

export default function HeroSlider() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % sliders.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const slide = sliders[current];

  return (
    <section className="relative overflow-hidden h-[360px] md:h-[500px]">
      {sliders.map((s, i) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-700 ${i === current ? 'opacity-100 z-10' : 'opacity-0 z-0'}`}
        >
          <ImageWithSkeleton
            src={s.img}
            alt={s.h1}
            containerClassName="w-full h-full"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-black/20" />
        </div>
      ))}

      {/* Content */}
      <div className="relative z-20 h-full max-w-7xl mx-auto px-4 flex items-center">
        <div className="max-w-lg">
          <h2
            key={`h2-${current}`}
            className="text-[#faffff] font-bold text-xl mb-2 animate-fade-in"
          >
            {slide.h2}
          </h2>
          <h1
            key={`h1-${current}`}
            className="text-white font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl mb-4 leading-tight animate-fade-in"
            style={{ animationDelay: '0.1s' }}
          >
            {slide.h1}
          </h1>
          <p
            key={`p-${current}`}
            className="text-white/90 text-md mb-6 animate-fade-in"
            style={{ animationDelay: '0.2s' }}
          >
            {slide.text}
          </p>
            <Link
              to="/products"
             className="btn-readmore px-8 py-3 animate-fade-in"
              style={{ animationDelay: '0.3s' }}
            >
              Read More
            </Link>
        </div>
      </div>

      {/* Dots */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex gap-2">
        {sliders.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`w-3 h-3 rounded-full transition-all ${i === current ? 'bg-primary scale-110' : 'bg-white/60 hover:bg-white'}`}
          />
        ))}
      </div>

      {/* Arrows */}
      <button
        onClick={() => setCurrent(prev => (prev - 1 + sliders.length) % sliders.length)}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 bg-white/20 hover:bg-primary text-white flex items-center justify-center transition-colors"
      >
        ‹
      </button>
      <button
        onClick={() => setCurrent(prev => (prev + 1) % sliders.length)}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 bg-white/20 hover:bg-primary text-white flex items-center justify-center transition-colors"
      >
        ›
      </button>
    </section>
  );
}
